export { CertificateCard } from './CertificateCard';

